import { Directive, HostBinding, HostListener, inject, Input, output } from '@angular/core';
import { Router } from '@angular/router';

/**
 * A link to a URL the server built, query string and fragment included - filter tags, pagination
 * and product choices all come back as one string. `routerLink` takes commands rather than a URL,
 * so the href is rendered as-is (crawlers and the browser's status bar see the real address) and
 * the click is handed to the router.
 */
@Directive({
  selector: 'a[storefrontUrl]'
})
export class UrlLinkDirective {

  @Input('storefrontUrl') @HostBinding('attr.href') url?: string | null;

  @Input() keepScroll = false;

  readonly navigated = output<string>();

  private router = inject(Router);

  @HostListener('click', ['$event'])
  navigate(event: MouseEvent) {
    if (!this.url || event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0) {
      return;
    }
    event.preventDefault();
    this.navigated.emit(this.url);
    void this.router.navigateByUrl(this.url, this.keepScroll ? { scroll: 'manual' } : {});
  }

}
